export default function notificationDataSelector(func) {
  return func((state) => state.notificationReducer);
}
